export enum FONT_TYPES {
  FONT_LIGHT = 'BeVietnamPro_300Light',
  FONT_REGULAR = 'BeVietnamPro_400Regular',
  FONT_SEMIBOLD = 'BeVietnamPro_600SemiBold',
  FONT_BOLD = 'BeVietnamPro_700Bold',
}
